import { Combobox } from '@/components/common/Combobox'
import { useRegions, useAssignUserRegion, useUnassignUserRegion } from '@/features/region/hooks'

interface UserRegionCellProps {
  userId: number
  /** Aktualnie przypisany region (kod) lub null. */
  regionCode: string | null
}

/** Dropdown przypisania handlowca do regionu (1 region/usera). "—" = brak przypisania. */
export function UserRegionCell({ userId, regionCode }: UserRegionCellProps) {
  const { data: regions } = useRegions()
  const assign = useAssignUserRegion()
  const unassign = useUnassignUserRegion()

  const options = (regions ?? []).map((r) => ({ value: r.code, label: r.labelPl }))
  const busy = assign.isPending || unassign.isPending

  const handleChange = (value: string | null) => {
    if (value) assign.mutate({ userId, regionCode: value })
    else unassign.mutate(userId)
  }

  return (
    <Combobox
      value={regionCode || null}
      onChange={handleChange}
      options={options}
      emptyOptionLabel="—"
      placeholder="Region…"
      disabled={busy}
      className="w-44"
    />
  )
}
